import { Chart } from '@frontend/chart/types';

import { createSingleSeriesTimeSeriesMockData } from '../../../mocks/create-time-series-mock-data';

export const VENDING_PACKAGE_VOLUME_LINE_CHART_MOCK_DATA: Chart = createSingleSeriesTimeSeriesMockData({
    days: 30,
    scale: 0.5,
    seriesName: 'Consumption volume'
});
